import { IconLayer, IconLayerProps, PathLayerProps, PolygonLayerProps } from "@deck.gl/layers"
import { get } from "nodash"
import { LngLatCoordinatePair } from "features/map/event/types"
import { AnyAction, LineProperties } from "@nova/constants"
import { Point } from "@nova/data-create-polygon-kml"
import { CompositeLayer, UpdateParameters } from "@deck.gl/core"
import { generateIconGeometry } from "plugins/Toolbox/Line/module"
import { Line } from "@nova/protobuf"
import { getGlobalTerrainData } from "features/map/GlobalTerrainManager"

export default class GeometryIconLayer<
    DataT extends { [key: string]: unknown } = AnyAction,
    ExtraProps extends {
        current: number
        zoomLevel?: number
        lineStyles: Partial<PathLayerProps>
        polygonStyles: Partial<PolygonLayerProps>
        thinLinePoint: LngLatCoordinatePair
        pickable: boolean
        canEdit?: (id: string) => boolean
        canExtend?: boolean
        drawLineProperties: LineProperties
        onLayerClick?: (id: string) => void
        iconWidth: number
    } = AnyAction,
> extends CompositeLayer<Required<IconLayerProps<DataT>> & ExtraProps> {
    state = {} as {
        data: { point: Point[]; icon: string; bearing: number }[]
    }
    static layerName = "geometry_icon_lines"

    updateState({ changeFlags }: UpdateParameters<this>) {
        const data = get(this.props, "data", {}) as Line[]
        const rebuildIndex = changeFlags.dataChanged

        if (rebuildIndex) {
            const iconData = generateIconGeometry(data, this.props.iconWidth)
            this.setState({ data: iconData })
        }
    }

    shouldUpdateState({ changeFlags }: UpdateParameters<this>) {
        return changeFlags.somethingChanged
    }

    renderLayers() {
        return [
            new IconLayer(
                this.getSubLayerProps({
                    data: this.state.data,
                    sizeUnits: "pixels",
                    getSize: this.props.iconWidth,
                    sizeScale: 1,
                    billboard: false,
                    updateTriggers: {
                        getIcon: this.state.data,
                        getPosition: this.state.data,
                    },
                    getIcon: (d: { iconUrl: string }) => {
                        return {
                            url: d.iconUrl,
                            height: this.props.iconWidth,
                            width: this.props.iconWidth,
                        }
                    },
                    getPosition: (d: { point: Point }) => d.point,
                    getAngle: (d: { bearing: number }) => d.bearing,
                    extensions: [...getGlobalTerrainData().extensions],
                    parameters: { depthTest: false },
                })
            ),
        ]
    }
}
